export default __webpack_public_path__ + "static/media/mapbox-logo.1a0cf7ca.svg";